import FormRow from './FormRow'
import { FormattedMessage } from 'react-intl'
import TravelDatepicker from '../../helpers/TravelDatepicker'

export default function TripDates({ errors, onChange, dateTo, dateFrom }) {
  return (<FormRow title={<FormattedMessage id='trip_dates' defaultMessage='Trip dates' />}>
    <label className={`date with-label ${errors.firstDay ? 'error-field' : ''}`}>
      <strong>
        <FormattedMessage id='from_to' defaultMessage='From & to' />
      </strong>
      <TravelDatepicker range dateTo={dateTo} dateFrom={dateFrom} callback={(val) => {
        onChange('firstDay', val.dateFrom)
        onChange('lastDay', val.dateTo)
      }} style={{ width: '100%' }} />
      <div className='error-text'>
        <FormattedMessage id='required_field' defaultMessage='This field is required!' />
      </div>
    </label>
  </FormRow>)
}
